<template>
    <v-carousel cycle hide-delimiter-background show-arrows-on-hover id="home-carousel" height="680px">
      <v-carousel-item eager src="../../assets/banners/1.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/2.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/3.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/4.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/5.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/6.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/7.jpg"></v-carousel-item>
      <v-carousel-item eager src="../../assets/banners/8.jpg"></v-carousel-item>
    </v-carousel>

</template>

<script>
export default {
  name: 'HomeMainCarousel',
  data: () => ({
  }),
};
</script>

<style scoped>
#logo {
  height: 100px;
  margin-top: 8px;
}
#title-container {
    width: 200px;
}
.card-inner {
    background: rgba(191, 191, 191, .5)
}
</style>
